var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h1',{staticStyle:{"text-align":"center","margin-top":"20vh","color":"#909399"}},[_c('i',{staticClass:"el-icon-guide"}),_vm._v(" 系统建设中... ")])}]

export { render, staticRenderFns }